module.exports = __webpack_public_path__ + "static/media/5.07eee144.png";